export const ThridSection = () => {
    const textData = [
        {
            title : "공인된 번역 단체에서 인증하는 자격증",
            content : <>
                일반 민간 단체에서 진행하는 자격증이 아니라 <br/>
                공인된 번역 단체에서 인증해 주는 자격증입니다.
            </>
        },
        {
            title : "대학 교수님들로 구성된 시험",
            content : <>
                대학교 현직 교수님들이 직접 출제하고 채점하는 방식으로 <br/>
                검증된 시험을 제공합니다.
            </>
        }
    ]
    
    return (
        <section className={`flex-col py-20 px-24 gap-9 bg-gray-100`}>
            {textData.map((data,idx) => (
                <div className={`flex items-center gap-12 ${idx == 1 ? "flex-row-reverse" : ""}`}>
                    <div className={`w-full text-center`}>
                        <h1 className={`text-3xl `}>{data.title}</h1>
                        <h2 className={`text-xl mt-3 font-light`}>{data.content}</h2>
                    </div>
                    <div className={`w-full`}>
                        <img src={`/images/home/section3/${idx+1}.png`} alt="" className={`w-full h-auto rounded-3xl`}/>
                    </div>
                </div>
            ))}
        </section>
    )
}